import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid2, Paper } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { load } from "@cashfreepayments/cashfree-js";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axiosInstance";
const OrderSummary = () => {
  const token = localStorage.getItem("token");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const baseUrl1 = import.meta.env.VITE_MAIN_URL;
  const navigate = useNavigate();
  const { id, data } = useParams();
  const parsedData = JSON.parse(decodeURIComponent(data));
  const [timer, setTimer] = useState(180);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };
  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      clearInterval(countdown);
      navigate("/DigitalGold");
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const handleSubmit = async () => {
    // setLoading(true);
    const data = {
      TotalAmount: parsedData.amountAfterTax,
      transaction_id: parsedData.merchant,
    };
    // step-1 : create order on server side and get the order_id from server side and pass it to the below function to open the cashfree checkout page.
    const buyOrder = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${Token}`,
        };
        const response = await axiosInstance.post(
          `/buy/${id}`,

          {
            metalType: parsedData.metalType,
            merchantTransactionId: parsedData.merchant,
            amount: parsedData.amount,
          },
          // { headers }
        );
        // const response = await axios.post(
        //   `${baseUrl}/buy/${id}`,

        //   {
        //     metalType: parsedData.metalType,
        //     merchantTransactionId: parsedData.merchant,
        //     amount: parsedData.amount,
        //   },
        //   { headers }
        // );

        // console.log("Success:", response.data);
        return response.data.data;
      } catch (error) {
        console.error(
          "Error:",
          error.response ? error.response.data : error.message,
        );
      }
    };
    // step-2 : open the cashfree checkout page with the order_id received from the server side.
    const handleOpenRazorpay = async (razorpayOrderSliceResponse) => {
      let cashfree;
      cashfree = await load({
        mode: "sandbox",
      });

      let checkoutOptions = {
        paymentSessionId: razorpayOrderSliceResponse.payment_session_id,
        redirectTarget: "_modal",
      };

      cashfree.checkout(checkoutOptions).then((result) => {
        if (result.error) {
          // console.log(
          //   "User has closed the popup or there is some payment error, Check for Payment Status",
          // );
          console.log(result.error);
        }
        if (result.redirect) {
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          // console.log("Payment has been completed, Check for Payment Status");
          // console.log(result.paymentDetails.paymentMessage);

          const response11 = buyOrder();

          console.log("================", response11);
          toast.success("Payment Successful");
          navigate("/buy_invoices");
        }
      });
    };
    // step-3 : call the buyOrder function to create order on server side and get the order_id from server side and pass it to the below function to open the cashfree checkout page.
    try {
      const res = await axiosInstance.post(
        `/Razorpay/${id}`,
        data,
        //   {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Accept: "application/json",
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      // const res = await axios.post(`${baseUrl}/Razorpay/${id}`, data, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Accept: "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });
      console.log("respomse nnnnnnnnnnnnn", res);
      const orderId = res.data?.data?.payment_session_id;
      console.log("orderId", orderId);
      if (orderId) {
        handleOpenRazorpay(res.data.data);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      console.error("Error during the request:", error);
    }
  };

  const handleSendLink = async () => {
    const data = {
      TotalAmount: parsedData.amountAfterTax,
      merchantTransactionId: parsedData.merchant,
    };

    try {
      const res = await axiosInstance.post(
        `/paymentLink/${id}`,
        data,
        //    {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Accept: "application/json",
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      // const res = await axios.post(`${baseUrl}/paymentLink/${id}`, data, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Accept: "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // });
      // console.log("respomse nnnnnnnnnnnnn", res.data.data);
      const response = res.data;
      if (response.error == false) {
        toast.success("Send Link Successful!");
        navigate("/DigitalGold");
      }
    } catch (error) {
      toast.error("Failed to send the link. Please try again.");
    }
  };

  const handleOpenRazorpay = async (razorpayOrderSliceResponse) => {
    let cashfree;
    cashfree = await load({
      mode: "sandbox",
    });

    let checkoutOptions = {
      paymentSessionId: razorpayOrderSliceResponse.payment_session_id,
      redirectTarget: "_modal",
    };

    cashfree.checkout(checkoutOptions).then((result) => {
      if (result.error) {
        console.log(
          "User has closed the popup or there is some payment error, Check for Payment Status",
        );
        // console.log(result.error);
      }
      if (result.redirect) {
        console.log("Payment will be redirected");
      }
      if (result.paymentDetails) {
        // console.log("Payment has been completed, Check for Payment Status");
        // console.log(result.paymentDetails.paymentMessage);

        const response11 = buyOrder();

        console.log("================", response11);
        toast.success("Payment Successful");
        navigate("/buy_invoices");
      }
    });
  };
  const buyOrder = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.post(
        `/buy/${id}`,

        {
          metalType: parsedData.metalType,
          merchantTransactionId: parsedData.merchant,
          amount: parsedData.amount,
        },
        // { headers }
      );
      // const response = await axios.post(
      //   `${baseUrl}/buy/${id}`,

      //   {
      //     metalType: parsedData.metalType,
      //     merchantTransactionId: parsedData.merchant,
      //     amount: parsedData.amount,
      //   },
      //   { headers }
      // );

      console.log("Success:", response.data);
      return response.data.data;
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message,
      );
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: "12px",
        maxWidth: "90vw",
        margin: "auto",
        mt: 5,
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", textAlign: "center", color: "#472878" }}
      >
        Order Summary
      </Typography>

      {/* Order Details */}
      <Grid2 item xs={6}>
        <Typography variant="body1" sx={{ color: "#6b6b6b", mb: 0 }}>
          {parsedData.metalType
            ? capitalizeFirstLetter(parsedData.metalType)
            : "Unknown"}{" "}
          Weight AUGMONT
        </Typography>
      </Grid2>
      <Grid2 item xs={6} textAlign="right">
        <Typography variant="body1">
          {parsedData.totalQuantity ? parsedData.totalQuantity : "N/A"}gm
        </Typography>
      </Grid2>
      <Grid2 item xs={6}>
        <Typography variant="body1" sx={{ color: "#6b6b6b", mb: 0 }}>
          {parsedData.metalType
            ? capitalizeFirstLetter(parsedData.metalType)
            : "Unknown"}{" "}
          Rate per gram
        </Typography>
      </Grid2>
      <Grid2 item xs={6} textAlign="right">
        <Typography variant="body1">
          ₹{parsedData.pricePerGram ? parsedData.pricePerGram : "N/A"}
        </Typography>
      </Grid2>
      <Grid2 item xs={6}>
        <Typography variant="body1" sx={{ color: "#6b6b6b", mb: 0 }}>
          {parsedData.metalType
            ? capitalizeFirstLetter(parsedData.metalType)
            : "Unknown"}{" "}
          Value Of per gram
        </Typography>
      </Grid2>
      <Grid2 item xs={6} textAlign="right">
        <Typography variant="body1">
          ₹{parsedData.amount ? parsedData.amount : "N/A"}
        </Typography>
      </Grid2>
      <Grid2 item xs={6}>
        <Typography variant="body1" sx={{ color: "#6b6b6b" }}>
          GST
        </Typography>
      </Grid2>
      <Grid2 item xs={6} textAlign="right">
        <Typography variant="body1">
          ₹{parsedData.gst ? parsedData.gst : "N/A"}
        </Typography>
      </Grid2>
      <Grid2 item xs={6}>
        <Typography
          variant="body1"
          sx={{ fontWeight: "bold", color: "#472878" }}
        >
          Total Amount
        </Typography>
      </Grid2>
      <Grid2 item xs={6} textAlign="right">
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          ₹{parsedData.amountAfterTax ? parsedData.amountAfterTax : "N/A"}
        </Typography>
      </Grid2>

      {/* Timer Section */}
      <Box
        textAlign="center"
        sx={{
          mt: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="body1" sx={{ color: "#6b6b6b" }}>
          This price will expire in :
          <Box
            component="span"
            sx={{
              display: "inline-block",
              // backgroundColor: "#472878",
              padding: "5px",
              border: "10px solid #472878",
              color: "black",
              borderRadius: "50%",

              lineHeight: "30px",
              ml: 1,
              fontWeight: "bold",
            }}
          >
            {formatTime(timer)}
          </Box>
        </Typography>

        {/* Company Info */}
        <Typography
          variant="body2"
          sx={{ mt: 2, fontWeight: "bold", color: "#472878" }}
        >
          Bharat Batuk Pvt Ltd (BBPL)
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#6b6b6b", textAlign: "center", mt: 1 }}
        >
          Gold bought in last 7 days cannot be sold. BBPL offers gold products
          through our partners. Refer to
          <Box component="span" sx={{ fontWeight: "bold", ml: 0.5 }}>
            Terms & Conditions
          </Box>
          of Gold for details.
        </Typography>

        {/* Buy Button */}
        <Box>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              mt: 3,
              mx: 2,
              backgroundColor: "#472878",
              "&:hover": { backgroundColor: "#37096b" },
            }}
          >
            BUY NOW
          </Button>
          <Button
            onClick={handleSendLink}
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#472878",
              "&:hover": { backgroundColor: "#37096b" },
            }}
          >
            Send Link
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default OrderSummary;
